import { css } from 'emotion'

export const largeCenterIconStyles = css`
  width: 100%;
  max-width: 550px;
  margin-top: 35px;
  font-size: 5em;
  margin-bottom: 30px;
`
